import ProfileCard from "./ProfileCard";

export default function Profile() {
	return <ProfileCard/>
}